import { cx } from "../../lib/cx.js";
import { formatCurrency } from "../../lib/format.js";
/* empty css          */
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Money/Money.tsx
/**
* The sign of a formatted amount: -1, 0 or 1, or null when it isn't valid. An amount that
* rounds to $0.00 is zero (no sign, no colour), as formatCurrency shows it.
*/
function signOf(formatted) {
	if (formatted === "—") return null;
	if (formatted === "$0.00") return 0;
	return formatted.startsWith("-") ? -1 : 1;
}
/**
* A dollar amount: `$1,234.56`, `-$1,234.56`, or `+$1,234.56` when `signed`. Tabular
* figures, so amounts line up in a column. Negatives are danger-coloured (tone `auto`)
* and keep their "-"; screen readers hear "minus $1,234.56".
*/
function Money({ value, size, tone = "auto", signed = false, currency: _currency = "USD", className, ...rest }) {
	const formatted = formatCurrency(value);
	const sign = signOf(formatted);
	const magnitude = formatted.replace(/^-/, "");
	const visible = sign === 1 && signed ? `+${formatted}` : formatted;
	const spoken = sign === -1 ? `minus ${magnitude}` : sign === 1 && signed ? `plus ${magnitude}` : null;
	const colour = tone === "auto" ? sign === -1 ? "negative" : null : tone === "neutral" ? null : tone;
	return /* @__PURE__ */ jsx("span", {
		...rest,
		className: cx("ds-money", size && `ds-money--${size}`, colour && `ds-money--${colour}`, className),
		children: spoken ? /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("span", {
			"aria-hidden": "true",
			children: visible
		}), /* @__PURE__ */ jsx("span", {
			className: "ds-money__spoken",
			children: spoken
		})] }) : visible
	});
}
//#endregion
export { Money };

//# sourceMappingURL=Money.js.map